module.exports = __webpack_public_path__ + "static/media/logo-black.bba7aa34.svg";